import _objectSpread from "/var/www/commonsku/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { addTelemetryDebug } from '@datadog/browser-core';
import { getLongTaskId } from '../utils/longTaskRegistry';
/**
 * Send RUM profile as JSON to public profiling intake.
 */
var sendProfile = function sendProfile(profilerTrace, endpointBuilder, applicationId, sessionId) {
  var event = buildProfileEvent(profilerTrace, endpointBuilder, applicationId, sessionId);
  var payload = buildProfilingPayload(profilerTrace, event);
  // Create URL, public profiling intake.
  var profilingIntakeURL = endpointBuilder.build('fetch', payload);
  addTelemetryDebug('Sending profile to public profiling intake', {
    profilingIntakeURL: profilingIntakeURL,
    applicationId: applicationId,
    sessionId: sessionId
  });
  // Send payload (event + profile as attachment).
  return fetch(profilingIntakeURL, {
    body: payload.data,
    method: 'POST'
  });
};
function buildProfileEvent(profilerTrace, endpointBuilder, applicationId, sessionId) {
  var tags = endpointBuilder.tags;
  var profileAttributes = buildProfileEventAttributes(profilerTrace, applicationId, sessionId);
  var profileEventTags = buildProfileEventTags(tags);
  var start = new Date(profilerTrace.timeOrigin + profilerTrace.startTime);
  var end = new Date(profilerTrace.timeOrigin + profilerTrace.endTime);
  var profileEvent = _objectSpread(_objectSpread({}, profileAttributes), {}, {
    attachments: ['wall-time.json'],
    start: start.toISOString(),
    end: end.toISOString(),
    family: 'chrome',
    runtime: 'chrome',
    format: 'json',
    version: 4,
    // Ingestion event version (not the version application tag)
    tags_profiler: profileEventTags.join(',')
  });
  return profileEvent;
}
/**
 * Builds tags for the Profile Event.
 * @param tags RUM tags
 * @returns Combined tags for the Profile Event.
 */
function buildProfileEventTags(tags) {
  // Tags already contains the common tags for all events. (service, env, version, etc.)
  // Here we are adding some specific-to-profiling tags.
  var profileEventTags = tags.concat(['language:javascript', 'runtime:chrome', 'family:chrome', 'host:browser']);
  return profileEventTags;
}
/**
 * Builds payload for Profiling intake. It includes the profile event and the profiler trace as attachment.
 * @param profilerTrace Profiler trace
 * @param profileEvent Profiling event.
 * @returns Payload to be sent to the intake.
 */
function buildProfilingPayload(profilerTrace, profileEvent) {
  var profilerTraceBlob = new Blob([JSON.stringify(profilerTrace)], {
    type: 'application/json'
  });
  var formData = new FormData();
  formData.append('event', new Blob([JSON.stringify(profileEvent)], {
    type: 'application/json'
  }), 'event.json');
  formData.append('wall-time.json', profilerTraceBlob, 'wall-time.json');
  return {
    data: formData,
    bytesCount: 0
  };
}
/**
 * Builds attributes for the Profile Event.
 * @param profilerTrace Profiler trace
 * @param applicationId application id.
 * @param sessionId session id.
 * @returns Additional attributes.
 */
function buildProfileEventAttributes(profilerTrace, applicationId, sessionId) {
  var attributes = {
    application: {
      id: applicationId
    }
  };
  if (sessionId) {
    attributes.session = {
      id: sessionId
    };
  }
  var viewIds = Array.from(new Set(profilerTrace.views.map(function (viewEntry) {
    return viewEntry.viewId;
  })));
  if (viewIds.length) {
    attributes.view = {
      id: viewIds
    };
  }
  var longTaskIds = profilerTrace.longTasks.map(function (longTask) {
    return getLongTaskId(longTask);
  }).filter(function (id) {
    return id !== undefined;
  });
  if (longTaskIds.length) {
    attributes.long_task = {
      id: longTaskIds
    };
  }
  return attributes;
}
export var transport = {
  sendProfile: sendProfile
};